class Exception {
  constructor({
    id = null,
    type = null,
    startDate = null,
    endDate = null,
    isExcused = false,
    user = null,
    description = null,
    replacedUser = null,
    replacementWorkShiftId = null,
    replacementWorkJourneyConfigId = null,
    rejectedDates = null,
  } = {}) {
    this.id = id;
    this.type = type;
    this.startDate = startDate;
    this.endDate = endDate;
    this.isExcused = isExcused;
    this.user = user;
    this.description = description;
    this.replacedUser = replacedUser;
    this.replacementWorkShiftId = replacementWorkShiftId;
    this.replacementWorkJourneyConfigId = replacementWorkJourneyConfigId;
    /** ISO dates (YYYY-MM-DD) rejected by the substitute; managed by backend services. */
    this.rejectedDates = rejectedDates;
  }

  /**
   * Prepare data for creating a new exception
   * @returns {Object} Data ready for creation
   */
  toCreate() {
    const data = {
      type: this.type,
      startDate: this.startDate,
      endDate: this.endDate,
      isExcused: this.isExcused,
      user: this.user,
      description: this.description,
      replacedUser: this.replacedUser,
      replacementWorkShiftId: this.replacementWorkShiftId,
      replacementWorkJourneyConfigId: this.replacementWorkJourneyConfigId,
    };

    // Clean up null/undefined values
    Object.keys(data).forEach(key => {
      if (data[key] === null || data[key] === undefined) {
        delete data[key];
      }
    });

    return data;
  }

  /**
   * Prepare data for updating an existing exception.
   * Omits `user` (immutable owner / substitute) and `rejectedDates` (backend-managed).
   * Replacement fields remain updatable for shift_replacement edits.
   * @returns {Object} Data ready for update
   */
  toUpdate() {
    const data = {
      type: this.type,
      startDate: this.startDate,
      endDate: this.endDate,
      isExcused: this.isExcused,
      description: this.description,
      replacedUser: this.replacedUser,
      replacementWorkShiftId: this.replacementWorkShiftId,
      replacementWorkJourneyConfigId: this.replacementWorkJourneyConfigId,
    };

    // Clean up null/undefined values
    Object.keys(data).forEach(key => {
      if (data[key] === null || data[key] === undefined) {
        delete data[key];
      }
    });

    return data;
  }

  /**
   * Convert instance to JSON
   * @returns {Object} JSON representation
   */
  toJson() {
    return {
      id: this.id,
      type: this.type,
      startDate: this.startDate,
      endDate: this.endDate,
      isExcused: this.isExcused,
      user: this.user,
      description: this.description,
      replacedUser: this.replacedUser,
      replacementWorkShiftId: this.replacementWorkShiftId,
      replacementWorkJourneyConfigId: this.replacementWorkJourneyConfigId,
      rejectedDates: this.rejectedDates,
    };
  }

  /**
   * Create Exception instance from raw data
   * @param {Object} data - Raw exception data
   * @returns {Exception} Exception instance
   */
  static fromData(data) {
    return new Exception({
      id: data.id,
      type: data.type,
      startDate: data.startDate,
      endDate: data.endDate,
      isExcused: data.isExcused,
      user: data.user,
      description: data.description,
      replacedUser: data.replacedUser,
      replacementWorkShiftId: data.replacementWorkShiftId,
      replacementWorkJourneyConfigId: data.replacementWorkJourneyConfigId,
      rejectedDates: data.rejectedDates,
    });
  }
}

export default Exception;
